import { BuyerType } from "@/framework/billing/stripe";
import { topupAmounts } from "@/framework/billing/topup/topupAmounts";

export type TopupLinkParams = {
  amount: number;
  buyerType: BuyerType;
  // Empty when the visitor has not picked a country.
  countryCode: string;
};

// Carries the pricing page selection over to the topup form, so the buyer does
// not have to pick amount, buyer type and country a second time.
export function topupHref({
  amount,
  buyerType,
  countryCode,
}: TopupLinkParams): string {
  const query = new URLSearchParams({ amount: String(amount), buyerType });
  if (countryCode !== "") {
    query.set("country", countryCode);
  }
  return `/account/topup?${query.toString()}`;
}

// Reads the same parameters back, ignoring anything we would not accept from
// the form itself.
export function parseTopupLinkParams(query: {
  [key: string]: string | string[] | undefined;
}): Partial<TopupLinkParams> {
  const amount = Number(single(query["amount"]));
  const buyerType = single(query["buyerType"]);
  const countryCode = single(query["country"]);
  return {
    amount: topupAmounts.includes(amount) ? amount : undefined,
    buyerType:
      buyerType === "business" || buyerType === "private"
        ? buyerType
        : undefined,
    countryCode:
      countryCode && /^[A-Z]{2}$/.test(countryCode) ? countryCode : undefined,
  };
}

const single = (value: string | string[] | undefined) =>
  Array.isArray(value) ? value[0] : value;
